import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: 'nz-steps[appNonFocusableSteps], ds-stepper[appNonFocusableSteps]',
})
export class NonFocusableStepsDirective implements AfterViewInit, OnDestroy {
  private observer?: MutationObserver;

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.removeTabStops();
    this.observer = new MutationObserver(() => this.removeTabStops());
    this.observer.observe(this.elementRef.nativeElement, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private removeTabStops(): void {
    const stepper = this.elementRef.nativeElement;
    this.renderer.setAttribute(stepper, 'tabindex', '-1');
    const focusableSteps = stepper.querySelectorAll<HTMLElement>('[tabindex]');
    focusableSteps.forEach((step) => this.renderer.setAttribute(step, 'tabindex', '-1'));
    stepper.shadowRoot?.querySelectorAll<HTMLElement>('[tabindex]').forEach((step) => this.renderer.setAttribute(step, 'tabindex', '-1'));
  }
}